
export const ID_SIDEBAR = 'sidebar';
export const ID_LIVESTREAM = 'livestream';
export const ID_MOBILE_CONTENT = 'mobile-content';
